import { render, staticRenderFns } from "./CardHistoryFormTab.vue?vue&type=template&id=2ed7c167"
import script from "./CardHistoryFormTab.vue?vue&type=script&lang=js"
export * from "./CardHistoryFormTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports